import { StockScannerEvent } from "../Markets/types";
import { stockScannerEventConfig } from "../Markets/ui/components/StockScanners/stockScannerConfig";
import type { ScreenerPreset } from "./type";

export const screenerPresets: readonly ScreenerPreset[] = [
	{
		presetName: "Earnings Momentum",
		options: [
			stockScannerEventConfig[StockScannerEvent.EARNINGS_MOMENTUM],
			stockScannerEventConfig[StockScannerEvent.HIGH_GROWTH],
			stockScannerEventConfig[StockScannerEvent.ACCELERATING],
			stockScannerEventConfig[StockScannerEvent.DECELERATING],
		],
	},
	{
		presetName: "Timing Momentum",
		options: [
			stockScannerEventConfig[StockScannerEvent.TIMING_MOMENTUM],
			stockScannerEventConfig[StockScannerEvent.RELATIVE_STRENGTH],
			stockScannerEventConfig[StockScannerEvent.RELATIVE_WEAKNESS],
		],
	},
	{
		presetName: "Price Action",
		options: [
			stockScannerEventConfig[StockScannerEvent.MOST_UP],
			stockScannerEventConfig[StockScannerEvent.MOST_DOWN],
			stockScannerEventConfig[StockScannerEvent.UP_VOLUME],
			stockScannerEventConfig[StockScannerEvent.DOWN_VOLUME],
			stockScannerEventConfig[StockScannerEvent.MOST_UP_CLOSE_TO_CLOSE],
			stockScannerEventConfig[StockScannerEvent.MOST_DOWN_CLOSE_TO_CLOSE],
			stockScannerEventConfig[StockScannerEvent.NEW_52W_HIGHS],
			stockScannerEventConfig[StockScannerEvent.NEW_52W_LOWS],
			stockScannerEventConfig[StockScannerEvent.UP_SLOPING_TRENDING],
			stockScannerEventConfig[StockScannerEvent.DOWN_SLOPING_TRENDING],
			stockScannerEventConfig[StockScannerEvent.POWERDAY_POSITIVE_BREAKOUTS],
			stockScannerEventConfig[StockScannerEvent.POWERDAY_NEGATIVE_BREAKOUTS],
		],
	},
	{
		presetName: "Fundamentals",
		options: [stockScannerEventConfig[StockScannerEvent.CAPITAL_EFFICIENCY]],
	},
	{
		presetName: "Forecast Models",
		options: [
			stockScannerEventConfig[StockScannerEvent.UPDRIFT],
			stockScannerEventConfig[StockScannerEvent.POWERDAYS],
		],
	},
	{
		presetName: "Value",
		options: [
			stockScannerEventConfig[StockScannerEvent.GARP],
			stockScannerEventConfig[StockScannerEvent.VALUE_PLAYS],
		],
	},
	{
		presetName: "Income",
		options: [stockScannerEventConfig[StockScannerEvent.INCOME_BEST]],
	},
	{
		presetName: "Analysts Views",
		options: [
			stockScannerEventConfig[StockScannerEvent.WALL_STREET_FAVS],
			stockScannerEventConfig[StockScannerEvent.REVISION_WINNERS],
			stockScannerEventConfig[StockScannerEvent.PRICE_TARGET_RAISED],
		],
	},
];

export const screenerPresetsFiltered = screenerPresets.map(
	({ presetName, options }) => ({
		presetName,
		options: options.map(({ text: _t, image: _i, ...rest }) => rest),
	}),
);
